import { GridCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { GearGridCell } from './GearGridCell';
import { GearSvgIcon } from '../../GearSvgIcon';
import { useGlobalizationContext } from '../../../context/globalization/GlobalizationContext';
import { useTranslation } from '../../../context/globalization/useTranslation';

interface RemoveCellProps extends GridCellProps {
  onClick: () => void;
}

export const RemoveCell: React.FC<RemoveCellProps> = props => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <GearGridCell {...props} customStyle={{ padding: 0 }} title={translate('custom.common.remove')}>
      <GearSvgIcon customIcon="removeIcon" className="removeIcon" onClick={props.onClick} role='button' />
    </GearGridCell>
  );
};
